import {
  TextInput as TextInputMantine,
  Button as ButtonMantine,
  Group as GroupMantine,
  Title as TitleMantine,
  Box as BoxMantine,
  PasswordInput as PasswordInputMantine
} from '@mantine/core'
import styled, { css } from 'styled-components'


export const HeaderWrapper = styled.div`
  height: 6.875em !important;
  display: flex !important;
  background-color: #f5f5f5;

  @media (max-width: 830px) {
    justify-content: space-evenly !important;
    padding: 0 20px !important;
  }
`

export const Header = styled.div`
  display: flex !important;
  justify-content: center !important;
  align-items: center !important;
  margin-left: 160px;
  background-color: #f5f5f5;

  @media (max-width: 830px) {
    margin-left: 0 !important;
    width: 100% !important;
    gap: 50px !important;
  }
`

export const Container = styled.div`
  width: 100% !important;
  background-color: #fff !important;
`

export const Form = styled.form`
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 12px;
`

export const ContentWrapper = styled.div`
  background-color: #fff !important;
  width: 100% !important;
  min-height: 100vh !important;
  flex-direction: column !important;
  display: flex !important;
  align-items: center !important;
`

export const Content = styled.div`
  display: flex !important;
`

export const ContainerImages = styled.div`
  display: flex !important;
  width: 100% !important;
  height: 66.5em !important;

  @media (max-width: 1675px) {
    height: 100vh !important;
  }
`

export const ContainerCarousel = styled.div`
  display: flex !important;
  width: 47.8% !important;

  @media (max-width: 1440px) {
    display: flex !important;
    width: 47.8% !important;
    margin-left: -250px;
  }
`

export const BlankSlateContainer = styled.div`
  padding-top: 30px;
  height: 305px;
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;

  @media (max-width: 830px) {
    padding-top: 50%;
  }
`

export const Box = styled(BoxMantine)`
  max-width: 470px;
  width: 100%;
  margin-left: 20px;
  display: inline-block;

  @media (max-width: 830px) {
    margin: 0px !important;
    max-width: 100%;
  }
`

export const Group = styled(GroupMantine)`
  width: 100%;
`

export const Button = styled(ButtonMantine)`
  background-color: #ffffff !important;
  color: #36d896 !important;

  :disabled {
    background-color: #cfd8dc !important;
    color: #00000042 !important;
  }

  @media (max-width: 830px) {
    background-color: #36d896 !important;
    color: #ffffff !important;
  }
`

export const ContainerForm = styled.div`
  width: 67% !important;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  margin: auto !important;
  margin-bottom: ${({ notHasData }) =>
    notHasData ? '20em' : '12em'}!important;
  margin-left: 9em !important;

  @media (max-width: 1036px) {
    margin-bottom: ${({ notHasData }) =>
      notHasData ? '20em' : '8em'}!important;
  }
`

export const ContainerFormMobile = styled.div`
  width: 100% !important;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding-left: 15px;
  padding-right: 15px;
  padding-bottom: 170px;
  max-width: 500px
`

export const Title = styled(TitleMantine)`
  color: #ffffff !important;
  text-align: left;
  margin-bottom: 20px !important;
  max-width: 1200px;
  font-weight: 700 !important;
  line-height: 1.3em !important;
  letter-spacing: 1px !important;
  font-family: Poppins;
  font-size: 36px;
  line-height: 48px;

  @media (max-width: 830px) {
    font-size: 20px !important;
    color: #36d896 !important;
  }
`

export const Paragraph = styled.p`
  color: #ffffff !important;
  text-align: left;
  font-size: 18px;
  max-width: 1200px;
  font-family: Roboto;
  font-weight: 700;

  @media (max-width: 830px) {
    color: #000 !important;
    font-size: 14px;
  }
`

export const Span = styled.p`
  color: #ffffff !important;
  text-align: left;
  max-width: 1200px;
  font-family: Roboto;
  font-weight: 400;
  font-size: 16px;

  @media (max-width: 830px) {
    color: #000 !important;
    font-size: 12px;
  }
`

export const MensagensErroWrapper = styled.div`
  display: flex !important;
  flex-direction: column !important;
  gap: 4px !important;
  border-radius: 8px !important;
  text-align: left !important;
`

export const TituloMensagem = styled.span`
  font-size: 16px;
  color: #000 !important;
  text-align: left !important;

  @media (max-width: 830px) {
    font-size: 14px;
  }
`

export const ValidacoesWrapper = styled.div`
  display: grid;
  gap: 2px;
`

export const GrupoValidacao = styled.div`
  font-size: 16px;
  display: flex;
  gap: 8px;
  color: #000 !important;

  ${({ subGrupo }) =>
    subGrupo &&
    css`
      padding-left: 20px;
    `}

  p {
    margin: 0;
  }

  img {
    margin-top: 6px;
    width: 16px;
    height: 16px;
  }

  @media (max-width: 830px) {
    font-size: 14px;

    img {
      margin-top: 3px;
      width: 14px;
      height: 14px;
    }
  }
`

export const Input = styled(TextInputMantine)`
  width: 100%;
  .mantine-InputWrapper-error {
    display: table !important;
  }

  .mantine-TextInput-input {
    color: #000000 !important;
    background-color: #ffffff !important;
    text-decoration: none !important;

    &:-webkit-autofill {
      transition: background-color 9999s ease-in-out 0s;
      -webkit-text-fill-color: #000 !important;
      caret-color: #000 !important;
    }
    &:-webkit-autofill,
    &:-webkit-autofill:hover,
    &:-webkit-autofill:focus,
    &:-webkit-autofill:active {
      box-shadow: 0 0 0px 1000px #ffffff inset !important;
      -webkit-box-shadow: 0 0 0px 1000px #ffffff inset !important;
      -webkit-text-fill-color: #000 !important;
    }
  }

  .mantine-InputWrapper-label {
    color: #ffffff !important;
    margin-bottom: 0px !important;
  }
`

export const PasswordInput = styled(PasswordInputMantine)`
  width: 100%;
  .mantine-PasswordInput-input {
    background-color: #ffffff !important;
  }
  .mantine-InputWrapper-error {
    display: table !important;
  }
  .mantine-PasswordInput-innerInput {
    color: #000000 !important;

    &:-webkit-autofill {
      transition: background-color 9999s ease-in-out 0s;
      -webkit-text-fill-color: #ffffff !important;
      caret-color: #ffffff;
    }
    &:-webkit-autofill,
    &:-webkit-autofill:hover,
    &:-webkit-autofill:focus,
    &:-webkit-autofill:active {
      box-shadow: 0 0 0px 1000px #ffffff inset !important;
      -webkit-box-shadow: 0 0 0px 1000px #ffffff inset !important;
      -webkit-text-fill-color: #000 !important;
    }

    /* Esconde o ícone nativo de mostrar/esconder senha do Edge */
    &::-ms-reveal,
    &::-ms-clear {
      display: none;
    }
  }

  .mantine-InputWrapper-label {
    color: #ffffff !important;
    margin-bottom: 0px !important;
  }
`
